<template>
    <div style="height: 100%;">
        <div class="top-box">
            <div>
                <div style="margin-right: 1rem;cursor: pointer;">搜索</div>
                <el-input v-model="pages.keyword" @keydown.enter.native="search" clearable @clear="search" placeholder="请输入关键字">
                    <template slot="prefix">
                        <div style="height: 100%;display: flex;align-items: center;">
                            <i class="iconfont icon-Magnifier"></i>
                        </div>
                    </template>
                </el-input>
            </div>
        </div>
        <div style="margin-top: 2rem;height: calc(100% - 6rem);">
            <Table
                :totalSize="tableTotal"
                :pagination="true"
                :operationWidth="350"
                @changeCurrentPage="changeCurrentPage"
                @changePageSize="changePageSize"
                :currentPage="pages.current"
                @SelectEvent="selectEvent"
                :pageSize="pages.size"
                navHeight=40
                ref="table"
                :tableData="tableData"
                :tableKey="tableKey"
            >
            <template slot="name" slot-scope="data">
                <el-input :disabled="disabled" placeholder="请输入" @blur="changeStatus(data.data.row)" v-model="data.data.row.name"></el-input>
            </template>
            <template slot="planCourseTime" slot-scope="data">
                <el-input  :disabled="disabled" type="number" @blur="changeStatus(data.data.row)" v-model="data.data.row.planCourseTime" placeholder="请输入"></el-input>
            </template>
            <template slot="mainType" slot-scope="data">
                <el-select v-model="data.data.row.mainType" :disabled="disabled" @change="changeMainType(data.data.row,'flag3')" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </template>
            <template slot="resourceName" slot-scope="data">
                <div style="cursor: pointer;" v-if="data.data.row.resourceName" :class="{'disabled-btn':disabled}" @click="openMain(data.data.row)" class="file-box">
                    <div>{{data.data.row.resourceName}}</div>
                    <i class="el-icon-paperclip"></i>
                </div>
                <div v-else-if="!data.data.row.resourceName" class="click-upload" @click="openMain(data.data.row)">
                    <div>点击选择</div>
                    <i class="el-icon-paperclip"></i>
                </div>
            </template>
            <template slot="bindResourceCount" slot-scope="data">
                <div>{{ data.data.row.bindResourceCount }}</div>
            </template>
            <template slot="operation" slot-scope="data">
                <div class="operation-box">
                    <el-tooltip class="item" effect="dark" content="添加资源" placement="top-start">
                        <i class="iconfont icon-tuceng" style="font-size: 16px;" @click="addResource(data.data.row)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                        <i class="el-icon-delete" style="margin-left: 1rem;font-size: 16px;" :class="{'disabled-btn':disabled}" @click="del(data.data.row)"></i>
                    </el-tooltip>
                </div>
            </template>
            </Table>
        </div>
        <add-ppt-resource ref="ppt" @cancel="operation=''" :teachUnit="currentRow"></add-ppt-resource>
        <add-simulate-resource ref="simulate" :teachUnit="currentRow"></add-simulate-resource>
        <add-video-resource ref="video" :teachUnit="currentRow"></add-video-resource>
        <main-dialog ref="main" @main_dialog="monitorResource"></main-dialog>
    </div>
</template>

<script>
import UploadResource from './UploadResource.vue';
import AddPptResource from '../addResource/AddPptResource.vue';
import AddSimulateResource from '../addResource/AddSimulateResource.vue';
import AddVideoResource from '../addResource/AddVideoResource.vue';
import { GetTeachingUnitList,UpdateTeachingUnit,DelTeachingUnit } from '@/api/teachUnit';
import MainDialog from './MainDialog.vue';
    export default {
        props:['disabled'],
        components:{UploadResource,AddPptResource, AddSimulateResource, AddVideoResource, MainDialog},
        data(){
            return {
                requestList:[],
                tableTotal:0,
                /**列表是否刷新完成 */
                hasRefresh:true,
                /**列表勾选的数据 */
                selectIds:[],
                tableData:[],
                tableKey:[
                {name: '教学单元名称', value: 'name',slot:'name'},
                {name: '计划课时', value: 'planCourseTime',slot:'planCourseTime'},
                {name: '主体呈现形式', value: 'mainType',slot:'mainType'},
                {name: '教学单元主体', value: 'resourceName',slot:'resourceName'},
                {name: '已绑定资源', value: 'bindResourceCount',slot:'bindResourceCount',width:'150'},
                {name: '操作', value: 'operation',slot:'operation'},
            ],
                pages:{
                    current:1,
                    size:10,
                    keyword:''
                },
                /**主体呈现形式可选项 */
                options:[
                    {
                        label:'ppt',
                        value:'ppt'
                    },
                    {
                        label:'视频',
                        value:'视频'
                    },
                    {
                        label:'仿真软件',
                        value:'仿真软件'
                    },
                ],
                /**教学单元主体可选项 */
                mainOptions:[],
                /**当前操作row */
                currentRow:{},
                /**主题资源形式 */
                mainType:'',
                operation:'',
                copyObj:{}
            }
        },
        computed:{
            courseId(){
                return this.$store.state.course.currentCourseId||this.$route.query.id||'';
            }
        },
        methods:{
            /**教学单元集合查询 */
            getTeachingUnitList(){
                return new Promise(resolve=>{
                    var params={
                    "courseId":this.courseId,
                    "current": this.pages.current,
                    "size": this.pages.size,
                    "name":this.pages.keyword
                    };
                    this.hasRefresh=false;
                    GetTeachingUnitList(params).then(res=>{
                        if(res.code==200){
                            this.tableData=res.data.records;
                            this.tableTotal=res.data.total;
                            this.hasRefresh=true;
                        }
                        resolve();
                    })
                })
            },
            changeCurrentPage(e){
                this.pages.current=e;
                this.getTeachingUnitList();
            },
            changePageSize(e){
            this.pages.size=e;
            this.pages.current=1;
            this.getTeachingUnitList();
            },
            changeStatus(item){
                this.copyObj=JSON.parse(JSON.stringify(item));
                this.updateCourseUnit(item);
            },
            /**批量删除课程章节信息 */
            delIdsCourseMenu(data){
                    var params={
                        ids:data
                    }
                DelTeachingUnit(params).then(res=>{
                        if(res.code==200){
                            if(this.tableData.length==1&&this.pages.current>1){
                                this.pages.current--;
                            }
                            this.getTeachingUnitList();
                        }
                    })
            },
            /**修改课程教学单元信息 */
            updateCourseUnit(data,callback){
               return new Promise(((resolve)=>{
                if(!this.hasRefresh){
                    this.$msg({
                                showClose: true,
                                message: "操作过于频繁，请等待列表刷新后再操作",
                                type: "warning",
                            });
                    return;
                }
                var params={
                "chapterId": data.chapterId,
                "courseId":this.courseId,
                "planCourseTime": data.planCourseTime,
                "id": data.id,
                "mainType": data.mainType,
                "dataType":data.dataType,
                "name": data.name,
                "resourceId": this.copyObj.resourceId===data.resourceId?null:data.resourceId
                }
                UpdateTeachingUnit(params).then(res=>{
                    if(res.code==200){
                        typeof callback=='function'&&callback();
                        this.getTeachingUnitList();
                    }else{
                        this.getTeachingUnitList();
                    }
                    resolve();
                }).catch(err=>{
                    this.getTeachingUnitList();
                });
               }))
            },
            /**删除 */
            del(data){
                if(this.disabled)return;
                this.delIdsCourseMenu([data.chapterId]);
            },
            /**打开关联单元主体弹窗 */
            openMain(data){
                if(this.disabled)return;
                if(!data.mainType){
                    this.$msg({
                                showClose: true,
                                message: "请先选择主题资源形式",
                                type: "warning",
                            });
                    return;
                }
                this.copyObj=JSON.parse(JSON.stringify(data));
                this.currentRow=data;
                var dialog=this.$refs.main;
                dialog.currentRaw=JSON.parse(JSON.stringify(data));
                delete  dialog.currentRaw.resourceName;
                dialog.init();
                dialog.changeCategory();
            },
            /**勾选列表数据 */
            selectEvent(e){
                this.selectIds=e;
            },
            /**搜索 */
            search(){
               this.pages.current=1;
               this.getTeachingUnitList();
            },
            addResource(data){
                if(!data.resourceId){
                    this.$msg({
                                showClose: true,
                                message: "请先选择资源",
                                type: "warning",
                            });
                    return;
                }
                this.currentRow=data;
                this.$nextTick(()=>{
                    var obj={
                    'ppt':'ppt',
                    '视频':'video',
                    '仿真软件':'simulate'
                }
                var dialog=this.$refs[obj[data.mainType]];
                if(dialog){
                    dialog.openInit();
                    dialog.changeCategory();
                    dialog.mainPreview(()=>{
                        dialog.dialogVisible=true;
                    }); 
                }
                })
            },
            /**切换主体资源形式 */
            changeMainType(item){
                item.resourceId='';
                this.updateCourseUnit(item)
            },
            /**监听上传资源 */
            monitorResource(){
               this.getTeachingUnitList();
            }
        },
    }
</script>

<style lang="less" scoped>
.upload{
    color: var(--blue);
    cursor: pointer;
}
.icon-jiahao{
    color: var(--blue);
    margin-right: 3px;
}
.top-box{
    display: flex;
    justify-content: flex-end;
    &> :nth-child(1){
        display: flex;
        align-items: center;
    }
}
.icon-Magnifier{
    color: #CFD5D9;
    font-weight: 600;
}
/deep/.el-input__inner{
    border-radius: 1rem;
}
/deep/.el-upload-dragger{
    width: 100%;
}
.operation-box{
    color: var(--blue);
    &> :nth-child(2){
        margin-left: 1rem;
    }
    &> :nth-child(n){
        cursor: pointer;
    }
}
.click-upload{
    display: flex;
    align-items: center;
    cursor: pointer;
    i{
        color: var(--blue);
        font-size: 1.8rem;
    }
}
.file-box{
    display: flex;
    align-items: center;
    i{
        color: var(--blue);
        font-size: 1.8rem;
    }
}
</style>